module.exports = __webpack_public_path__ + "img/albert_wilson.3ff86a15.png";